import { AutoMap } from "@automapper/classes";

export class ZoneEntity {

    Id?: number;
    @AutoMap()
    TaskStatus!: number
    @AutoMap()
    Code!: string
    @AutoMap()
    SamplingDate!: string;
    @AutoMap()
    ZoneSalle!: string;
    @AutoMap()
    DateDernierLavage!: string;
    @AutoMap()
    ConditionPrelevement!: number;

    PrelevementQualifSalleId?: number;
    PrelevementAirIds!: number[];
    PrelevementSurfaceIds!: number[];
}